import { render, staticRenderFns } from "./QuotationDetailsCard.vue?vue&type=template&id=73f2cc5c"
import script from "./QuotationDetailsCard.vue?vue&type=script&lang=ts"
export * from "./QuotationDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports